import { render, staticRenderFns } from "./AdvListItem.vue?vue&type=template&id=2ad876da&"
import script from "./AdvListItem.vue?vue&type=script&lang=js&"
export * from "./AdvListItem.vue?vue&type=script&lang=js&"
import style0 from "./AdvListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports